import { ListItem, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { fantasyTheme } from '../theme/fantasyTheme';
const theme = fantasyTheme;

export const GGMenuListItem = ({ onClick, icon, label, color }) => (
    <ListItem 
      onClick={onClick}
      sx={{ 
        color: color || 'inherit',
        '&:hover': {
          backgroundColor: 'rgba(44, 62, 80, 0.1)'
        }
      }}
    >
      <ListItemIcon sx={{ color: color || theme.palette.text.primary }}>
        {icon}
      </ListItemIcon>
      <ListItemText sx={{ color: color || theme.palette.text.secondary }} primary={label} />
    </ListItem>
);

export const GGMenuItem = ({ onClick, icon, label, color }) => (
  <MenuItem onClick={onClick} sx={{ color: color || 'inherit', '&:hover': { backgroundColor: 'rgba(44, 62, 80, 0.1)' } }}>
    <ListItemIcon sx={{ color: color || theme.palette.text.primary }}>
      {icon}
    </ListItemIcon>
    <ListItemText sx={{ color: color || theme.palette.text.secondary }} primary={label} />
  </MenuItem>
);